
import { Type } from '@angular/core';
import { AbstractFormFieldComponent } from '../../../Common/PageBuilder/components/FormField/abstract-form-field.component';
import { FormFieldModel } from '../../../Common/PageBuilder/models/form-field.model';

export class FooterFieldModel implements FormFieldModel {
    fieldComponent: Type<AbstractFormFieldComponent>;
    property: string;
    label: string;
    description: string;
    multiline: boolean;
    maxLength: number;
    placeholder: string;

    constructor(
        fieldComponent: Type<AbstractFormFieldComponent>,
    ) {
        this.fieldComponent = fieldComponent;
        this.property = 'footer';
    }
}
